/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetProResultExportDataParams,
  GetProfessionalUsersParams,
  GetRepResultExportDataParams,
  GetRepUsersParams,
  HTTPValidationError,
  SearchExportResponse,
  UserListResponse,
} from './platformapi.schemas';

import getProResultExportDataMutator from '../custom-axios-instance';
import getProfessionalUsersMutator from '../custom-axios-instance';
import getRepResultExportDataMutator from '../custom-axios-instance';
import getRepUsersMutator from '../custom-axios-instance';

/**
 * Get a list of professional users based on filter criteria for export.
 * @summary Get Pro Result Export Data
 */
export const getProResultExportData = (
  params?: GetProResultExportDataParams,
  signal?: AbortSignal,
) => {
  return getProResultExportDataMutator<SearchExportResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/pro-export-results`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProResultExportDataQueryKey = (params?: GetProResultExportDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/pro-export-results`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProResultExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProResultExportDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProResultExportData>>> = ({ signal }) =>
    getProResultExportData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProResultExportData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProResultExportDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProResultExportData>>
>;
export type GetProResultExportDataQueryError = HTTPValidationError;

export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetProResultExportDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getProResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getProResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pro Result Export Data
 */

export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProResultExportDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a paginated list of professional users based on filter criteria.
 * @summary Get Professional Users
 */
export const getProfessionalUsers = (params?: GetProfessionalUsersParams, signal?: AbortSignal) => {
  return getProfessionalUsersMutator<UserListResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/professional-users`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProfessionalUsersQueryKey = (params?: GetProfessionalUsersParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/professional-users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProfessionalUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfessionalUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfessionalUsers>>> = ({ signal }) =>
    getProfessionalUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfessionalUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProfessionalUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfessionalUsers>>
>;
export type GetProfessionalUsersQueryError = HTTPValidationError;

export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetProfessionalUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalUsers>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalUsers>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Professional Users
 */

export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProfessionalUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a list of representative users based on filter criteria for export.
 * @summary Get Rep Result Export Data
 */
export const getRepResultExportData = (
  params?: GetRepResultExportDataParams,
  signal?: AbortSignal,
) => {
  return getRepResultExportDataMutator<SearchExportResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/rep-export-results`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetRepResultExportDataQueryKey = (params?: GetRepResultExportDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/rep-export-results`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRepResultExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRepResultExportDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepResultExportData>>> = ({ signal }) =>
    getRepResultExportData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRepResultExportData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRepResultExportDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRepResultExportData>>
>;
export type GetRepResultExportDataQueryError = HTTPValidationError;

export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetRepResultExportDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getRepResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getRepResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Rep Result Export Data
 */

export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRepResultExportDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a paginated list of representative users based on filter criteria.
 * @summary Get Rep Users
 */
export const getRepUsers = (params?: GetRepUsersParams, signal?: AbortSignal) => {
  return getRepUsersMutator<UserListResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/rep-users`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetRepUsersQueryKey = (params?: GetRepUsersParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/rep-users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRepUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRepUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepUsers>>> = ({ signal }) =>
    getRepUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRepUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRepUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getRepUsers>>>;
export type GetRepUsersQueryError = HTTPValidationError;

export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetRepUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepUsers>>,
          TError,
          Awaited<ReturnType<typeof getRepUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepUsers>>,
          TError,
          Awaited<ReturnType<typeof getRepUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Rep Users
 */

export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRepUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
